import { AuthenticateAction } from '../actions/authenticateActions'
import { Error } from '../../types/error'
import { AuthenticateSmartcheckSessionDto } from '../../types/authenticateSmartcheckSessionDto'

export enum AuthenticateStatus {
	IDLE = 'idle',
	AUTHENTICATING = 'authenticating',
	AUTHENTICATING_WITH_SUBDOMAIN = 'authenticatingWithSubdomain',
	AUTHENTICATING_WITH_SUBDOMAIN_SUCCESS = 'authenticatingWithSubdomainSuccess',
	AUTHENTICATE_SUCCESS = 'authenticateSuccess',
	AUTHENTICATE_FAILURE = 'authenticateFailure',
}

export interface AuthenticationState {
	status: AuthenticateStatus
	authenticateError?: Error
	applicantId: string | null
	instructionId?: string
	smartCheckAuthenticationDto?: AuthenticateSmartcheckSessionDto
}

const INITIAL_STATE: AuthenticationState = {
	status: AuthenticateStatus.IDLE,
	applicantId: null,
}

const idleSessionReducer = (
	state: AuthenticationState,
	action: AuthenticateAction,
): AuthenticationState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/authenticateWithApplicantId':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATING,
				applicantId: action.payload.applicantId,
			}
		case 'smartCheckFlowOrchestrator/authenticateFailed':
			const status =
				action.payload.errorCode === 'Missing_Authentication_Parameter'
					? AuthenticateStatus.AUTHENTICATING
					: AuthenticateStatus.AUTHENTICATE_FAILURE
			return { ...state, status }
		default:
			return state
	}
}

const authenticatingSessionReducer = (
	state: AuthenticationState,
	action: AuthenticateAction,
): AuthenticationState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/authenticateSucceeded':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATE_SUCCESS,
				applicantId: action.payload.applicantId,
				smartCheckAuthenticationDto: action.payload.smartCheckAuthenticationDto,
			}
		case 'smartCheckFlowOrchestrator/authenticateFailed':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATE_FAILURE,
				authenticateError: action.payload,
			}
		case 'smartCheckFlowOrchestrator/authenticateWithSubdomain':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATING_WITH_SUBDOMAIN_SUCCESS,
			}
		default:
			return state
	}
}

const authenticateSuccessSessionReducer = (
	state: AuthenticationState,
	action: AuthenticateAction,
): AuthenticationState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/authenticateWithApplicantId':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATING,
				applicantId: action.payload.applicantId,
			}
		default:
			return state
	}
}

const authenticateFailureSessionReducer = (
	state: AuthenticationState,
	action: AuthenticateAction,
): AuthenticationState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/authenticateWithApplicantId':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATING,
				applicantId: action.payload.applicantId,
			}
		default:
			return state
	}
}

const authenticateWithSubdomainSuccessReducer = (
	state: AuthenticationState,
	action: AuthenticateAction,
): AuthenticationState => {
	switch (action.type) {
		case 'smartCheckFlowOrchestrator/authenticateWithApplicantId':
			return {
				...state,
				status: AuthenticateStatus.AUTHENTICATING,
				applicantId: action.payload.applicantId,
			}
		default:
			return state
	}
}

export default function reduce(
	state: AuthenticationState = INITIAL_STATE,
	action: AuthenticateAction,
): AuthenticationState {
	switch (state.status) {
		case AuthenticateStatus.IDLE:
			return idleSessionReducer(state, action)
		case AuthenticateStatus.AUTHENTICATING:
			return authenticatingSessionReducer(state, action)
		case AuthenticateStatus.AUTHENTICATE_SUCCESS:
			return authenticateSuccessSessionReducer(state, action)
		case AuthenticateStatus.AUTHENTICATE_FAILURE:
			return authenticateFailureSessionReducer(state, action)
		case AuthenticateStatus.AUTHENTICATING_WITH_SUBDOMAIN_SUCCESS:
			return authenticateWithSubdomainSuccessReducer(state, action)
		default:
			//	TODO log as error
			return state
	}
}
